// src/composables/chatState.ts
import { reactive, readonly } from "vue";
import { ChatType } from "./chatService";

interface ChatState {
  position: "bottom-right" | "center";
  isVisible: boolean;
  unreadCount: number;
  currentRoomId: string;
  token: string;
  type: ChatType;
  globalUnreadCount: number;
  clickType: number;
}

const state = reactive<ChatState>({
  position: "bottom-right",
  isVisible: false,
  unreadCount: 0,
  currentRoomId: "",
  token: "",
  type: "home",
  globalUnreadCount: 0,
  clickType: 0,
});

export const chatState = readonly(state);

export function setChatPosition(position: "bottom-right" | "center") {
  state.position = position;
}

export function toggleChat(value?: boolean) {
  state.clickType++;
  state.isVisible = value !== undefined ? value : !state.isVisible;
}

export function incrementUnreadCount() {
  state.unreadCount++;
}
export function changeUnreadCount(count: number) {
  state.unreadCount = count;
}
export function resetUnreadCount() {
  state.unreadCount = 0;
}

export function setCurrentRoomId(roomId: string) {
  state.currentRoomId = roomId;
}
export function setType(type: ChatType) {
  state.type = type;
}
export function quitChat() {
  localStorage.removeItem("chatRoomId");
  state.currentRoomId = "";
}

export function setToken(token: string) {
  state.token = token;
}

export function updateGlobalUnreadCount(count: number) {
  state.globalUnreadCount = count;
}

export function getGlobalUnreadCount() {
  return state.globalUnreadCount;
}
